import React from 'react';
import { YoutubeBlock } from './YoutubeBlock';

export interface YoutubeListBlockProps {
  attrs?: any;
}

export const YoutubeListBlock: React.FC<YoutubeListBlockProps> = ({ attrs }) => {
  const ids = attrs?.data?.youtube_ids;
  if (!ids) return null;

  return (
    <div className="youtube-list-block">
      {ids.map(id => (
        <YoutubeBlock videoId={id} />
      ))}
    </div>
  );
};

export default YoutubeListBlock;
